<template>
	<main id="main" class="main">
		<section class="lists">
			<div class="inner">
				<div class="mobile_arrow left">
					<img class="search" src="@/assets/arrow.svg" />
				</div>
				<div class="mobile_arrow right">
					<img class="search" src="@/assets/arrow.svg" />
				</div>
				<!-- 電腦版tab -->
				<div id="tablinks" class="tabs tablinks">
					<button
						v-for="(tab, index) in tabList"
						:key="`tab-${index}`"
						:class="{'active': tabActive === index}"
						class="tablink Sheet1_Click"
						@click="clickTablink(index)"
					>
						{{ tab }}
					</button>
				</div>
				<div class="cats tabcontent">
				<a
					v-for="(article, index) in articleData"
					:key="`${tabList[tabActive]}-${index}`"
					class="item"
					:href="article.link"
					target="_blank"
					rel="noreferrer noopener"
					@click="sendAnalytic('Blogger', 'Click', `blogger_${article.detail.author.name}`)"
				>
					<div class="img">
					<img :src="article.image" />
					</div>
					<div class="description">
					<p>{{ article.title }}</p>
					</div>
				</a>
				</div>
			</div>
			<div
				class="hamburger"
				@click="sideMenuActive = !sideMenuActive"
			>
			</div>
			<!-- 手機版menu -->
			<div
				class="side_menu"
				:class="{ 'active': sideMenuActive }"
			>
				<div class="top">
					<div
						class="close"
						@click="sideMenuActive = !sideMenuActive"
					>
						<img src="@/assets/close.svg" />
					</div>
				</div>
				<div
					v-for="(tab, index) in tabList"
					:key="`tab-mb-${index}`"
					:class="{'active': tabActive === index}"
					class="tablink Sheet1_Click"
					@click="clickTablink(index)"
				>
					{{ tab }}
				</div>
			</div>
		</section>
		<!-- 看更多文章 -->
		<section class="more-article">
			<button class="btn-more js-more-article Content_more_click"
					v-show="pageOption.page < pageOption.pageTotal"
					@click="getMoreArticleData()">看更多文章</button>
		</section>
	</main>
</template>

<script setup>
import { ref, reactive, onMounted } from 'vue';
import sendAnalytic from '@/common/sendAnalytic';
import { TAB_LIST, getArticlesPage } from '@/data/articles';

const tabList = TAB_LIST;
const tabActive = ref(0);
const sideMenuActive = ref(false);

const articleData = ref([]);

/** 頁數控制
 * @param {number} page 當前頁數
 * @param {number} pageSize 一頁幾筆資料
 */
const pageOption = reactive({
	page: 1,
	pageTotal: 1
})

const clickTablink = id => {
	tabActive.value = id;
	getArticleData();
	sendAnalytic('Sheet', 'Click', `Sheet${id+1}_Click`);
}

/** 取得文章
 * @param {string} tagName tag 名稱
 * @param {number} mode 模式。 1: 取得文章（初始） 2: 更多文章
 * @param {number} pageSize 一頁幾筆資料
 * @param {number} page 當前頁數
 */
const getArticleData = ( mode = 1, page = 1, pageSize = 9 ) => {
	pageOption.page = page;
	const { articles, pageTotal } = getArticlesPage(
		tabList[tabActive.value],
		pageOption.page,
		pageSize
	);

	if (mode === 1) {
		articleData.value = articles;
	} else {
		articleData.value.push(...articles);
	}

	pageOption.pageTotal = pageTotal;
};

const getMoreArticleData = () => {
	pageOption.page++;
	getArticleData(2, pageOption.page);
	sendAnalytic('Content', 'Click', 'Content_more_click');
}

onMounted(() => {
	getArticleData();
});

</script>
